import React from "react";
// import MindMePaymentsLogo from "../../../../../../images/logos/mindme-payments-logo-center.png";
import MerchantAccountStore from "../MerchantAccountStore";
import { NavigateFunction } from "react-router-dom";
import styled from "styled-components";
import {
  AuthService,
  CustomButton,
  CustomLabel,
  CustomWidth,
  FlexContainer,
  SoftRedButton,
  ToastService,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { MainOuterCard } from "../../../shared/styles";
import { RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccount } from "../../../shared/models";
import { IAPIDeleteMerchantAccount } from "../../../shared/interfaces";
import {  MerchantAccountService } from "../../../shared/services";
import { ApplicationStatus } from "../../../shared/enums";

type IProps = {
  merchantAccountStore: MerchantAccountStore;
  navigate: NavigateFunction;
  id: string;
  rolesAndPermissionStore: RolesAndPermissionStore;
  getMerchantAccounts: () => void;
};
export const MerchantApplicationSuccessWrapper = styled.div`
  height: inherit;
  ${MainOuterCard} {
    padding: 50px 0px;
    border-radius: 10px;
    min-height: 100%;
    img {
      height: 90px;
      width: auto;
      margin-bottom: 20px;
    }
  }
  &.nmi-application ${MainOuterCard} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .nmi-success-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 25px;
    max-width: 720px;
    margin: 0 auto;
    img {
      margin-bottom: 0;
    }
  }
  .nmi-success-message {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 500px;
  }
  ${CustomLabel} {
    &:not(.merchant-account-name) {
      font-size: 20px;
      font-weight: 400;
      line-height: 27px;
      text-align: center;
    }
    &.merchant-account-name {
      font-size: 30px;
      font-weight: 600;
      line-height: 40px;
      text-align: center;
    }
    span {
      margin-top: 25px;
      display: inline-block;
      margin-bottom: 40px;
    }
  }
`;

const MerchantApplicationSuccess: React.FC<IProps> = ({
  merchantAccountStore,
  rolesAndPermissionStore,
  id,
  navigate,
  getMerchantAccounts,
}) => {
  const onCompleteApplication = (applicationId: string) => {
    if (
      !rolesAndPermissionStore.hasManageMerchantAccountPermission("Complete the Application")
    ) {
      return;
    }
    merchantAccountStore.fetchCompleteApplicationLink(applicationId);
  };

  const handleMerchantAccountAction = (
    item: MerchantAccount,
    actionType: "delete" | "cancel"
  ) => {
    if (!rolesAndPermissionStore.hasManagePermission(actionType)) return;
    const data = item.createAPIModel2();
    const apiModel: IAPIDeleteMerchantAccount = {
      accountId: AuthService.authData?.accountId || "",
      merchantAccount: data,
    };

    const actionService =
      actionType === "delete"
        ? MerchantAccountService.deleteMerchantAccount(apiModel)
        : MerchantAccountService.cancelMerchantAccount(apiModel);

    actionService.subscribe({
      next: (result) => {
        if (!result.result) {
          const errorMessage =
            actionType === "delete"
              ? "Error in deleting merchant account"
              : "Error in cancelling application";
          ToastService.showError(errorMessage);
        } else {
          const successMessage =
            actionType === "delete"
              ? "Merchant Account deleted successfully"
              : "Application cancelled successfully";
          ToastService.showSuccess(successMessage);
        }
        getMerchantAccounts();
        navigate("/app/merchant-accounts");
      },
      error: () => {
        const errorMessage =
          actionType === "delete"
            ? "Error in deleting merchant account"
            : "Error in cancelling application";
        ToastService.showError(errorMessage);
      },
    });
  };

  const merchantAccountsData: MerchantAccount[] =
    merchantAccountStore.merchantAccounts;
  const merchantAccount = merchantAccountsData.find((m) => m.id === id);
  if (!merchantAccount) return <></>;

  const isNMI = merchantAccount.isNMIMerchantAccount();

  const renderSinglePendingCard = () => {
    return (
      <>
        <FlexContainer
          alignItems="center"
          justifyContent="center"
          fxLayout="column"
          spacing={30}
        >
          <img src={merchantAccount.getLogo()} />
          <CustomLabel>
            Congratulations! You have successfully created a merchant
            application for:
          </CustomLabel>
          <CustomLabel className="merchant-account-name">
            {merchantAccount.name}
            {/* The Pizza Shack of Delaware */}
          </CustomLabel>
          <CustomWidth width="650px">
            <CustomLabel>
              Click the button below to complete all remaining required
              information, sign electronically and submit for review. <br />
              <span> Most applications are approved within 15 minutes. </span>
            </CustomLabel>
          </CustomWidth>
          <FlexContainer
            alignItems="center"
            justifyContent="center"
            spacing={25}
          >
            <SoftRedButton
              bgColor="#fff"
              borderColor="#556bb8"
              color="#556bb8"
              height="40px"
              onClick={() =>
                handleMerchantAccountAction(merchantAccount, "cancel")
              }
            >
              Cancel Application
            </SoftRedButton>
            {
              merchantAccount.isFiservMerchantAccount() && <CustomButton
                bgColor="#556bb8"
                borderColor="#556bb8"
                color="#fff"
                height="40px"
                onClick={() =>
                  onCompleteApplication(merchantAccount.applicationId)
                }
              >
                Complete Application
              </CustomButton>
            }

          </FlexContainer>
        </FlexContainer>
      </>
    );
  };

  const renderNMIPendingCard = () => {
    const isActive =
      merchantAccount.applicationStatus === ApplicationStatus.Active;
    return (
      <div className="nmi-success-card">
        <img src={merchantAccount.getLogo()} />
        <CustomLabel>
          Congratulations! You have successfully connected a merchant account
          for:
        </CustomLabel>
        <CustomLabel className="merchant-account-name">
          {merchantAccount.name}
        </CustomLabel>
        <div className="nmi-success-message">
          {isActive ? (
            <CustomLabel>
              Your merchant account is connected and active. You can start taking
              payments right away.
            </CustomLabel>
          ) : (
            <>
              <CustomLabel>
                Your details have been submitted, but this merchant account is
                not active yet.
              </CustomLabel>
              <CustomLabel>
                Please contact your administrator to activate it before you can
                start taking payments.
              </CustomLabel>
            </>
          )}
        </div>
        <SoftRedButton
          bgColor="#fff"
          borderColor="#556bb8"
          color="#556bb8"
          height="40px"
          onClick={() => handleMerchantAccountAction(merchantAccount, "cancel")}
        >
          Cancel Application
        </SoftRedButton>
      </div>
    );
  };

  return (
    <MerchantApplicationSuccessWrapper
      className={isNMI ? "nmi-application" : ""}
    >
      <MainOuterCard>
        {isNMI ? renderNMIPendingCard() : renderSinglePendingCard()}
      </MainOuterCard>
    </MerchantApplicationSuccessWrapper>
  );
};

export default withRouter(MerchantApplicationSuccess);
